import { RG_TYPE } from "@project-rouge/rg-core";
import { getPivot, Vector3toV3, applyTransform } from "@project-rouge/rg-three";
import { sort2dObjsbyVector } from "./index158.js";
function getCorridorCorners(module, apartment) {
  if (apartment.data.closeCorridor && apartment.data.closeDirection) {
    const dir = [apartment.data.closeDirection[0], apartment.data.closeDirection[2]];
    const modules = sort2dObjsbyVector(apartment.children.filter((ch) => ch.type === RG_TYPE.Module), dir);
    if (module.uuid === modules[modules.length - 1].uuid && modules.length > 1) {
      const z = getPivot([0, 0, 1], modules[0]).z;
      const relativeStart = getPivot([0, 0, 1], module);
      const relativeEnd = getPivot([1, 0, 1], module);
      const relativeCorrStart = [relativeStart.x, relativeStart.y, z];
      const relativeCorrEnd = [relativeEnd.x, relativeEnd.y, z];
      const start2 = Vector3toV3(applyTransform(relativeCorrStart, apartment));
      const end2 = Vector3toV3(applyTransform(relativeCorrEnd, apartment));
      return { start: start2, end: end2 };
    }
  }
  const start = Vector3toV3(applyTransform(getPivot([0, 0, 1], module), apartment));
  const end = Vector3toV3(applyTransform(getPivot([1, 0, 1], module), apartment));
  return { start, end };
}
export {
  getCorridorCorners
};
//# sourceMappingURL=index153.js.map
